export default __webpack_public_path__ + "007f50bfb0e1a434c75d03ede5f5e3f1.png";